import React, { useEffect, useState } from "react";
import { Toaster } from "react-hot-toast";
import { useHistory } from "react-router-dom";
import Button from "../../../../components/Button";
import InputSelect from "../../../../components/Input-select";
import Spinner from "../../../../components/Spinner";
import { TableComponent, TH, THeadTR } from "../../../../components/Table v2";
import { toastError, toastSuccess } from "../../../../components/Toast";
import useAuthData from "../../../../hook/useAppData";
import { IconCheck, IconLeftArrowVersion2, IconPencilRevert, IconX } from "../../../../icons";
import { currentDate, _formatDate } from "../../../../libs/dateUtils";
import { renderName } from "../../../../libs/getInitialLetters";
import { orderByName } from "../../../../libs/orderList";
import { IFieldValues as ICliendData } from "../../../Client/components/form/model";
import { getClientById } from "../../../Client/service";
import { ACCESS } from "../../../Profile/constants";
import { CreateProjectUsers, ReqProjects } from "../../model";
import { service } from "../../service/service";
import "./index.scss";

interface IDataProjectDetails extends CreateProjectUsers {
  is_deleted?: CreateProjectUsers["isDeleted"];
}

interface ICollaboratorProject {
  userId: number;
  name: string;
  allocationTime: string;
}

export default function ListProjectDetails({ match }) {
  const { token, accessIds, userId } = useAuthData();
  const [dataProject, setDataProject] = useState<IDataProjectDetails>();
  const [dataClient, setDataClient] = useState<ICliendData>();
  const [listCollaboratorOfProject, setListCollaboratorOfProject] = useState<ICollaboratorProject[]>([]);
  const [needSpinner, setNeedSpinner] = useState(true);
  const history = useHistory();
  const id = match?.params?.id;

  useEffect(() => {
    getData();
  }, []);

  useEffect(() => {
    setNeedSpinner(true);
    setTimeout(() => {
      setNeedSpinner(false);
    }, 1000);
  }, [dataProject, dataClient]);

  async function getData() {
    const idClientOfProject = await getProject();
    await getClient(idClientOfProject);
  }

  async function getProject() {
    const dataService: ReqProjects = await service.getByIdProjects(id, token);
    getCollaborators(dataService);
    setDataProject(dataService?.project);
    return dataService?.project?.clientId;
  }

  async function getClient(idClientOfProject: number) {
    const dataService: ICliendData = await getClientById(token, idClientOfProject);
    setDataClient(dataService);
  }

  function getCollaborators(dataService: ReqProjects) {
    const collaboratorsProject = dataService?.project?.collaborators;
    const collaborators: any[] = dataService?.users;
    const userInProject = [];

    for (let user of collaborators) {
      collaboratorsProject.forEach((userProject) => {
        if (userProject.userId === user.id) userInProject.push({ ...userProject, name: user.name });
      });
    }
    const userOrderByName = orderByName(userInProject?.filter(Boolean), "name");
    setListCollaboratorOfProject(userOrderByName);
  }

  const optionsActionProject = {
    delete: "Cancelado",
    finish: "Concluído",
    active: "Ativo",
  };
  const actionsProject = {
    delete: "Cancelar",
    finish: "Concluir",
    active: "Ativar",
  };

  async function handleChangeStateProject(action: "delete" | "finish" | "active") {
    const dataOfReq = { body: JSON.stringify(changeData(action)), file: undefined };
    const res = await service.putProjects(dataOfReq, id, token);
    verefyRes(res, action);
    updateDataLocal(action);
  }

  function changeData(action) {
    const newDataProject: typeof dataProject = {
      ...dataProject,
      isDeleted: action !== "active" ? true : false,
      status: optionsActionProject[action] as "Cancelado" | "Concluído" | "Ativo",
      endDate: action !== "active" ? _formatDate(currentDate()) : "",
    };
    delete newDataProject["is_deleted"];
    return newDataProject;
  }

  function verefyRes(res, action) {
    if (!res?.ok) return toastError(`Não foi possível ${actionsProject[action]} esse projeto`);
    toastSuccess(`Projeto ${action !== "active" ? optionsActionProject[action] : "Ativado"} com sucesso`);
  }

  function updateDataLocal(action) {
    setDataProject({
      ...dataProject,
      status: optionsActionProject[action] as "Cancelado" | "Concluído" | "Ativo",
      is_deleted: action !== "active" ? true : false,
    });
  }

  function handleBackClick() {
    history.goBack();
  }

  function handleEditProject() {
    history.push(`/projects/form/${id}`);
  }

  return (
    <>
      <Toaster />
      <div className="header-project-details">
        {" "}
        <span onClick={() => handleBackClick()} className="cursor-pointer">
          {IconLeftArrowVersion2}
        </span>{" "}
        <h1>{dataProject?.name}</h1>
      </div>
      <div className="container-project-details">
        <Spinner status={needSpinner} classNameFather="project-details-info">
          <div className="project-details-info-full bg-primary  h-220px ">
            <div className="project-details-info-header">
              <span
                className={`project-details-info-status ${
                  (dataProject?.status === "Ativo" && "text-green-500") ||
                  (dataProject?.status === "Concluído" && "text-gray-500") ||
                  (dataProject?.status === "Cancelado" && "text-red-500") ||
                  (!dataProject?.status && "text-textPrimary")
                }`}
              >
                {dataProject?.status || "Não informado"}
              </span>
              <h3>{dataProject?.name}</h3>
              <h5>{dataClient?.name}</h5>
            </div>
            <div className="project-details-info-image">
              {dataProject?.img ? (
                <img src={dataProject?.img} />
              ) : (
                <div className="project-details-info-image-initials">
                  <h1>{renderName(dataProject?.name)}</h1>
                </div>
              )}
            </div>
          </div>
          <div className="project-details-info-contact">
            <div>
              <h1>Responsável</h1>
              <span>{dataProject?.projectManager ? dataProject?.projectManager : "Responsável não definido"}</span>
            </div>
            {dataClient?.phone ||
              (dataClient?.email && (
                <div>
                  <h1>Responsável</h1>
                  <span>{dataClient?.email || dataClient?.phone}</span>
                </div>
              ))}
          </div>
          <hr />
          <div className="project-details-info-buttons ">
            {accessIds?.includes(ACCESS.PROJECT_write) ? (
              <Button
                onClick={() => (dataProject?.is_deleted ? handleChangeStateProject("active") : handleChangeStateProject("finish"))}
                className="project-details-info-buttons-default bg-primary "
              >
                <span>{IconCheck}</span>
                {dataProject?.is_deleted ? <span>ATIVAR PROJETO</span> : <span>FINALIZAR PROJETO</span>}
              </Button>
            ) : (
              ""
            )}
            <Button className="project-details-info-buttons-default bg-white border-2 border-primary ">
              <span className="text-primary"> {IconPencilRevert}</span>
              <span onClick={() => handleEditProject()} className="text-primary">
                {" "}
                {accessIds?.includes(ACCESS.PROJECT_write) ? "EDITAR" : "VISUALIZAR"} INFORMAÇÕES DO PROJETO
              </span>
            </Button>
            {!dataProject?.is_deleted && accessIds?.includes(ACCESS.PROJECT_write) ? (
              <Button
                onClick={() => handleChangeStateProject("delete")}
                className="project-details-info-buttons-default bg-white border-2 border-red-600 text-red-600 "
              >
                <span className="icon-inactive-project bg-red-600 text-white rounded-full mx-1">{IconX}</span>
                <span>DESATIVAR PROJETO</span>
              </Button>
            ) : (
              ""
            )}
          </div>
        </Spinner>

        <DetailsProjectRight listCollaboratorOfProject={listCollaboratorOfProject} accessIds={accessIds} userId={userId} />
      </div>
    </>
  );
}

function DetailsProjectRight({
  listCollaboratorOfProject,
  accessIds,
  userId,
}: {
  listCollaboratorOfProject: ICollaboratorProject[];
  accessIds: number[];
  userId: number;
}) {
  const [userFilterValue, setUserFilterValue] = useState("");
  const [list, setList] = useState<ICollaboratorProject[]>(listCollaboratorOfProject);
  const [needSpinner, setNeedSpinner] = useState(true);
  const history = useHistory();

  useEffect(() => {
    setNeedSpinner(true);
    if (!list?.length && !userFilterValue) return setList(listCollaboratorOfProject);
    setNeedSpinner(false);
  }, [list, listCollaboratorOfProject]);

  function handleFilterChange(e) {
    const value = e.target.value;
    if (!value) return;
    setUserFilterValue(value);
    const newList = listCollaboratorOfProject?.filter((item) => item?.name === value);
    setList(newList);
  }

  function handleClearFilter() {
    setList(listCollaboratorOfProject);
    setUserFilterValue("");
  }

  function handleRowClickRedirect(collaborator: ICollaboratorProject) {
    history.push(`/collaborator/form/${collaborator?.userId}`);
  }

  return (
    <div className="project-details-list">
      <div className="project-details-list-header bg-primary h-100px">
        <div className="project-details-list-header-hours">
          <h2>156:51</h2>
          <div>
            <span>Horas</span>
            <span>Minutos</span>
          </div>
        </div>
        <div className="project-details-list-header-image">
          <h6>Profissionais nesse projeto</h6>
          <div className="flex flex-row-reverse">
            {listCollaboratorOfProject?.length > 5 && <span className=" w-12 h-12">+{listCollaboratorOfProject?.length - 5}</span>}
            <div className="flex">
              {listCollaboratorOfProject?.map((collaborator, index) => {
                return (
                  index < 5 && (
                    <div
                      key={collaborator?.userId}
                      className={`flex text-center items-center justify-center w-12 h-12 rounded-full border-2 border-background bg-white ${
                        index !== 0 && "-ml-3"
                      }`}
                    >
                      <h1 className="text-blueDark font-familyPoppins text-base font-bold">{renderName(collaborator?.name)}</h1>
                    </div>
                    // <img src={image} className={`w-12 rounded-full ${index !== 0 && "-ml-3"}`} />
                  )
                );
              })}
            </div>
          </div>
        </div>
      </div>

      <Spinner status={needSpinner}>
        <div className="project-details-list-filter">
          <div className="flex items-end w-4/12">
            <InputSelect
              value={userFilterValue === "" ? 0 : userFilterValue}
              onChange={(e) => handleFilterChange(e)}
              name="input1"
              label="Profissional"
              placeholder="Todos"
              list={listCollaboratorOfProject}
            />
            {/* </div>
          <div className="items-end flex h-3/6"> */}
            <Button onClick={() => handleClearFilter()} className="bg-secondary mb-4">
              Limpar
            </Button>
          </div>
          {/* <div className="flex 2xl:flex-row xl:flex-wrap w-6/12">
        <Input type="date" value={0} setValue={() => {}} name="input1" label="Data Inicial" placeholder="DD/MM/AAAA" />
        <Input type="date" value={0} setValue={() => {}} name="input1" label="Data Final" placeholder="DD/MM/AAAA" />
      </div> */}
        </div>
        <TableComponent className="overflow-y-auto h-16 2xl:max-h-64 2xl:min-h-36rem">
          <THeadTR>
            <TH className="w-4/6">
              <div className="pl-3 justify-start"> Profissional</div>
            </TH>
            {/* <TH className="w-1/6">Data</TH> */}
            <TH className="w-2/6">Alocação de %</TH>
          </THeadTR>
          <tbody>
            {list?.map((collaborator) => {
              return (
                <tr
                  key={collaborator?.userId}
                  onClick={() => {
                    if (collaborator?.userId !== userId && accessIds?.includes(ACCESS.USERS_DATA_all)) handleRowClickRedirect(collaborator);
                    else if (collaborator?.userId === userId) handleRowClickRedirect(collaborator);
                  }}
                  className={`border-b border-background transition duration-300 hover:ease-in filter hover:brightness-50 
                  ${collaborator?.userId !== userId && accessIds?.includes(ACCESS.USERS_DATA_all) ? " cursor-pointer" : ""} 
                  ${collaborator?.userId === userId ? " cursor-pointer" : ""}`}
                >
                  <td className="flex gap-4 items-center border-none">
                    {/* <img src={image} className="w-10 rounded-full border-2 border-background" /> */}
                    <div className="flex text-center items-center justify-center w-10 h-10 rounded-full border-2 border-background">
                      <h2 className="text-base font-semibold">{renderName(collaborator?.name)}</h2>
                    </div>{" "}
                    {collaborator?.name}
                  </td>
                  <td className="border-none text-center">
                    {(Number(collaborator?.allocationTime) * 100).toFixed(2)}%
                  </td>
                </tr>
              );
            })}
          </tbody>
        </TableComponent>
      </Spinner>
    </div>
  );
} 
